/*
 * @Author: cc
 * @Date: 2019-12-13 12:43:10
 * @LastEditTime: 2022-01-20 15:55:33
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editListPart\service\newMediaService.js
 * @Description:新媒体渠道服务（抖音、百家号、企鹅号、头条号）
 */

angular.module('newMediaServiceModule', ['flowWithVerifierModule']).factory('newMediaService', [
    '$q',
    '$window',
    '$timeout',
    '$state',
    'trsHttpService',
    'modalDialog',
    'messagePublishService',
    'initVersionService',
    'editingCenterService',
    'trsspliceString',
    'storageListenerService',
    'previewService',
    '$filter',
    'editNewspaperService',
    '$sessionStorage',
    'localStorageService',
    'sensitiveWordCheckService',
    'myManuscriptService',
    '$modal',
    function (
        $q,
        $window,
        $timeout,
        $state,
        trsHttpService,
        modalDialog,
        messagePublishService,
        initVersionService,
        editingCenterService,
        trsspliceString,
        storageListenerService, // 不要删除eval表达式要使用
        previewService,
        $filter,
        editNewspaperService,
        $sessionStorage,
        localStorageService,
        sensitiveWordCheckService,
        myManuscriptService,
        $modal
    ) {
        var mediaPath = {
            // 融合编辑打开流程版本使用到的数据
            '-1': 'editingCenterFusionPersonalVersionTime',
            '1': 'editingCenterAppPersonalVersionTime',
            '2': 'editingCenterWebsitePersonalVersionTime',
            '3': 'editingCenterPaperPersonalVersionTime',
            '4': 'editingCenterWeixinPersonalVersionTime',
        };

        /**
         * [isPass description]
         *
         * @param {[type]} selectedArray   [selectedArray description]
         * @param {[type]} canPass   [canPass description]
         *
         * @return {[type]}   [return description]
         */
        function isPass(selectedArray, canPass) {
            for (var i = 0; i < selectedArray.length; i++) {
                // TrialResult   0 正常状态  1 指定审核人状态      2 通过状态  3 不通过状态
                if (canPass && selectedArray[i].TRIALRESULT === '2') {
                    modalDialog.alertType('选中的稿件中存在已通过的稿件，请重新选择', '', 'warning');
                    return false;
                } else if (!canPass && selectedArray[i].TRIALRESULT !== '2') {
                    modalDialog.alertType('选中的稿件中存在未通过的稿件，请重新选择', '', 'warning');
                    return false;
                }
            }
            return true;
        }

        /**
         * [editPageDeal description]编辑页面处理
         * @param   {[str]}   trench      [trench description]渠道名称
         * @return  {[undefined]}         [return description]
         */
        function editPageDeal(trench) {
            eval('storageListenerService.addListenerTo' + trench.replace(trench[0], trench[0].toUpperCase()) + "('send')");
        }

        /**
         * [doRequest description] 发送请求
         * @param   {[object]}  params             [params description] 请求参数
         * @param   {[string]}  trench             [trench description] 渠道名称
         * @param   {[string]}  forbiddenError     [trench description] 是否忽略请求错误提示（这里主要为了强制签发）
         * @return  {[object]}                     [return description] promise对象
         */
        function doRequest(params, trench, forbiddenError) {
            let defer = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', forbiddenError).then(
                (data) => {
                    successAfterRequest(trench, data);
                    defer.resolve(data);
                },
                (error) => {
                    failAfterRequest(trench);
                    defer.reject(error);
                }
            );
            return defer.promise;
        }

        /**
         * [doSign description] 执行签发
         * @param   {[object]}  scope      [params description] 对应页面的$scope
         * @param   {[object]}  params      [params description]
         * @param   {[string]}  trench      [trench description]
         * @param   {[function]}  callback  [callback description]
         * @return  {[undefined]}            [return description]
         */
        function doSign(scope, params, trench, callback) {
            let defer = $q.defer();
            let pageDiffer = distinguishListOrEdit(scope);
            scope.loadingPromise = doRequest(params, trench, true).then(() => {
                if (!pageDiffer.isEdit) {
                    scope.requestData();
                }
                defer.resolve();
            }, (error) => {
                var options = {
                    params: params
                };
                callback ? options.callback = callback : '';
                editingCenterService.issuedByForce(error, options).then(function (result) {
                    if (result) {
                        successAfterRequest(trench, result);
                    } else {
                        failAfterRequest(trench);
                    }
                    if (!pageDiffer.isEdit) {
                        scope.requestData();
                    }
                }, function () {
                    failAfterRequest(trench);
                    if (!pageDiffer.isEdit) {
                        scope.requestData();
                    }
                });
                defer.reject();
            });
            return defer.promise;
        }


        /**
         * [successAfterRequest description] 请求成功后的操作
         * @param   {[string]}  trench        [trench description] 渠道名
         * @param   {[object]}  data          [clearArray description] 后端返回值
         * @return  {[undefined]}             [return description]
         */
        function successAfterRequest(trench, data) {
            if (data) {
                modalDialog.multiReportsAlert(data, () => {
                    // 要执行的操作
                });
            }
            if (trench) {
                // 有渠道表明是编辑页面，需要通过缓存刷新列表
                editPageDeal(trench);
                $timeout(function () {
                    $window.close();
                }, 2000);
            }
        }

        /**
         * [failAfterRequest description] 请求失败后的操作
         * @param   {[str]}  trench        [trench description]渠道名
         * @return  {[undefined]}          [return description]
         */
        function failAfterRequest(trench) {
            if (!trench) {
                messagePublishService.publish('refresh', true);
            } else {
                // 有渠道表明是编辑页面，需要通过缓存刷新列表,请求失败也关闭编辑页面
                editPageDeal(trench);
            }
        }

        /**
         * [examineDoctype description] 检查稿件类型
         * @param   {[type]}  array  [array description]
         * @param   {[type]}  type   [type description]
         * @return  {[type]}         [return description]
         */
        function examineDoctype(array, type) {
            var defer = $q.defer();
            for (var i = 0; i < array.length; i++) {
                if (type.indexOf(array[i].DOCTYPE) < 0) {
                    defer.reject();
                    break;
                }
            }
            defer.resolve();
            return defer.promise;
        }

        /**
         * [geRelatedversion description] 融合稿获取关联流程版本
         * @param  {[type]} MetaDataId [description]
         * @param  {[type]} num        [description]
         * @return {[type]}            [description]
         */
        function getRelatedversion(MetaDataId, num) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_fusionmyrelease',
                methodname: 'getObjversionByDoc',
                METADATAID: MetaDataId,
                VersionNum: num,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
         * [examDistributionType description]
         * @param  {[type]} elm [description]
         * @return {[type]}     [description]
         */
        function examDistributionType(elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID * 1 !== 1 && elm.DOCTYPEID * 1 !== 7 && elm.DOCTYPEID * 1 !== 2;
            }
        }

        /**
         * [distinguishListOrEdit description] 判断当前调用方法的页面是列表还是编辑页
         * @param   {[object]}  scope  [scope description]
         * @return  {[object]}         [return description] 按钮操作需要的内容
         */
        function distinguishListOrEdit(scope) {
            if (scope && scope.data && scope.data.selectedArray) {
                return {
                    list: scope.data.selectedArray,
                    isEdit: false,
                };
            } else {
                return {
                    list: [scope.list],
                    isEdit: true,
                };
            }
        }

        /**
         * [packageGeneralParams description] 组装通用操作参数（送审、签发、撤稿等）
         * @param   {[type]}  trench       [scope description]
         * @param   {[type]}  pageDiffer  [pageDiffer description]
         * @return  {[type]}              [return description]
         */
        function packageParams(trench, pageDiffer) {
            let params = {};
            switch (trench) {
                case 'Iwo':
                    params = {
                        ChnlDocIds: trsspliceString.spliceString(pageDiffer.list, 'CHNLDOCID', ','),
                        MetaDataIds: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ',')
                    };
                    break;
                case 'Trill':
                    params = {
                        douYinArticleIds: trsspliceString.spliceString(pageDiffer.list, 'DOUYINARTICLEID', ','),
                        douYinArticleId: trsspliceString.spliceString(pageDiffer.list, 'DOUYINARTICLEID', ','),
                        accountId: $state.params.account,
                    };
                    break;
                case 'Kuaishou':
                    params = {
                        DocIds: trsspliceString.spliceString(pageDiffer.list, 'KUAISHOUARTICLEID', ','),
                        DocId: trsspliceString.spliceString(pageDiffer.list, 'KUAISHOUARTICLEID', ','),
                        accountId: $state.params.account,
                    };
                    break;    
                case 'Toutiaohao':
                    params = {
                        METADATAIDS: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        METADATAID: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        CHANNELID: $state.params.account,
                        ChnlDocIds: trsspliceString.spliceString(pageDiffer.list, 'CHNLDOCID', ','),
                    };
                    break;
                case 'Baijiahao':
                    params = {
                        baiJiaHaoArticleIds: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        baiJiaHaoArticleId: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        accountId: $state.params.account || pageDiffer.list[0].BAIJIAHAOACCOUNTID,
                    };
                    break;
                case 'Qiehao':
                    params = {
                        objectids: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        accountId: $state.params.account || pageDiffer.list[0].ACCOUNTID,
                        qieHaoArticleIds: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                    };
                    break;
                case 'App':
                    params = {
                        MetaDataIds: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        MetaDataId: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        ChnlDocIds: trsspliceString.spliceString(pageDiffer.list, 'CHNLDOCID', ','),
                        ChannelId: $state.params.channelid || '0', // 兼容iwo渠道选中app时没有该字段
                    };
                    break;
                case 'Weixin':
                    params = {
                        MetaDataIds: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        MetaDataId: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        ChnlDocIds: trsspliceString.spliceString(pageDiffer.list, 'CHNLDOCID', ','),
                        CurrChnlId: $state.params.wxchannelid,
                        ChannelId: $state.params.wxchannelid,
                    };
                    break;
                case 'Website':
                    params = {
                        MetaDataIds: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        MetaDataId: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                        ChnlDocIds: trsspliceString.spliceString(pageDiffer.list, 'CHNLDOCID', ','),
                        ChannelId: pageDiffer.list[0].CHANNELID,
                        CurrChnlId: pageDiffer.list[0].CHANNELID,
                    };
                    break;
                case 'Weibo':
                    params = {
                        ObjectIds: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                    };
                    break;
                case 'Fusion': // 融合待编和融合审签送审、签发等操作组织参数，可见https://wiki.trscd.com.cn/pages/viewpage.action?spaceKey=CDBIGDATA&title=XJRB-2903
                    var manuscriptArr = [];
                    pageDiffer.list.forEach(function (item) {
                        manuscriptArr.push({
                            MEDIATYPE: item.MEDIATYPE,
                            DOCID: item.METADATAID
                        });
                    });
                    params = {
                        mediaTypeDocIds: JSON.stringify(manuscriptArr)
                    };
            }
            return params;
        }

        /**
         * [afterNewsSign description]
         * @param   {[type]}  result      [result description]
         * @param   {[type]}  isEdit      [isEdit description]
         * @param   {[type]}  scope       [scope description]
         * @return  {[type]}              [return description]
         */
        function afterNewsSign(result, isEdit, scope) {
            if (isEdit) {
                if (angular.isDefined(result.reports[0])) {
                    result.paperid = $state.params.paperid;
                    editNewspaperService.singZpInfo(result, function () {
                        storageListenerService.addListenerToNewspaper();
                        $window.close();
                    });
                }
            } else {
                scope.requestData().then(() => {
                    if (angular.isDefined(result.reports[0])) {
                        result.paperid = $state.params.paperid;
                        editNewspaperService.singZpInfo(result, function () {
                            scope.requestData();
                        });
                    }
                });
            }
        }

        /**
         * [signZp description]稿件签发照排操作
         * @param  {[object]}   pageDiffer       [description] 被选中的稿件
         * @param  {[object]} scope       [description] 调用方法页面的scope
         * @return {[type]}               [description]
         */
        function newsSignZp(pageDiffer, scope) {
            let ISZHAOPAI;
            if (pageDiffer.isEdit) {
                ISZHAOPAI = scope.status.newInformation.ISZHAOPAI;
            } else {
                ISZHAOPAI = scope.data.paperMsg.ISZHAOPAI;
            }
            if (ISZHAOPAI === '0') {
                editNewspaperService.stopSignZp(pageDiffer.list, function () {
                    if (pageDiffer.isEdit) {
                        storageListenerService.addListenerToNewspaper();
                        $window.close();
                    } else {
                        scope.requestData();
                    }
                }, function (result) {
                    afterNewsSign(result, pageDiffer.isEdit, scope);
                },
                function () { },
                {
                    methodname: scope.status.sbgedit || $state.params.newspapertype === '2' ? 'doQianFa' : 'doQianFaJinRi'
                }
                );
            } else {
                editNewspaperService.useSignZP(
                    pageDiffer.list,
                    function () {
                        if (pageDiffer.isEdit) {
                            storageListenerService.addListenerToNewspaper();
                            $window.close();
                        } else {
                            scope.requestData();
                        }
                    },
                    function (result) {
                        afterNewsSign(result, pageDiffer.isEdit, scope);
                    },
                    function () { },
                    {
                        methodname: scope.status.sbgedit || ($state.params.newspapertype && $state.params.newspapertype.toString() === '2') ? 'doQianFa' : 'doQianFaJinRi'
                    }
                );
            }
        }

        /**
         * [isAcross description] 判断是否含有跨版转版的稿件
         * @param  {[type]}  item   [item description]
         * @return  {[type]}   [return description]
         */
        function isAcross(item) {
            var defer = $q.defer();
            var items = [];
            for (var i = 0; i < item.length; i++) {
                if (item[i].FLAG === '1') {
                    items.push(item[i]);
                }
            }
            if (items.length) {
                editNewspaperService.acrossAlert(items).then(function () {
                    defer.resolve();
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [selectedSingleDoctype description] 判断选中稿件是否属于同一类型
         * @param   {[array]}  list  [list description] 稿件集合
         * @return  {[type]}         [return description]
         */
        function selectedSingleDoctype(list) {
            var doctype = list[0].DOCTYPEID;
            for (var i = 0; i < list.length; i++) {
                if (doctype !== list[i].DOCTYPEID) {
                    return false;
                }
            }
            return true;
        }

        /**
         * [formatParams description] 整理送审参数
         * @param  {[type]}  selected   [selected description]
         * @return  {[type]}   [return description]
         */
        function formatParams(selected) {
            var params = {};
            params.verifyType = selected.selectedType;
            switch (params.verifyType) {
                case 0:
                    params.userIds = trsspliceString.spliceString(selected.selectedArray, 'ID', ',');
                    break;
                case 1:
                    params.userGroups = trsspliceString.spliceString(selected.selectedArray, 'GROUPID', ',');
                    break;
            }
            return params;
        }

        // function getReviseInfo(item, type) {
        /**
         * [getReviseInfo description] 获取修订信息
         * @param   {[array]}  list [item description] 稿件信息
         * @param   {[string]} type [type description] 具体渠道下的状态标识字段
         * @return  {[type]}        [return description]
         */
        function getReviseInfo(list, type) {
            if (list && !angular.isArray(list)){
                list = [list];
            }
            type = type || 'DOCMODIFYSTATUSNAME';
            let collections = list.filter((item) => item[type] === '待修订');
            if (!collections.length) {
                return;
            }
            trsHttpService
                .httpServer(
                    trsHttpService.getWCMRootUrl(),
                    {
                        serviceid: 'mlf_modifydoc',
                        methodname: 'queryPaperModifyDocInfo',
                        // PaperDocId: item.METADATAID,
                        PaperDocId: trsspliceString.spliceString(collections, 'METADATAID', ','),
                    },
                    'get'
                )
                .then(function (data) {
                    if (data.length) {
                        list.map((item, index) => {
                            data.forEach((resI) => {
                                if (item.METADATAID === resI.PAPERDOCID) {
                                    item.APPOINTUSER = resI.APPOINTUSER;
                                    item.MODIFYUSER = resI.MODIFYUSER;
                                    item.MODIFYTIME = resI.CRTIME;
                                }
                            });
                        });
                    }
                });
        }
        return {

            /**
             * [isPass description] 通过和取消通过按钮函数
             *
             * @param {[type]} selectedArray   [selectedArray description] 选中的稿件数据
             * @param {[type]} flag   [flag description] 通过/取消通过 true/false
             *
             * @return {[type]}   [return description]
             */
            isPass(selectedArray, flag) {
                var defer = $q.defer();
                if (!isPass(selectedArray, flag)) {
                    defer.reject();
                } else {
                    modalDialog.confirmModal(flag ? '通过' : '取消通过', '确认' + (flag ? '通过' : '取消通过') + '?', function () {
                        var params = {
                            serviceid: 'mlf_fusion',
                            methodname: 'passOrNotPassVerifyDoc',
                            docIds: trsspliceString.spliceString(selectedArray, 'METADATAID', ','), // 稿件ids
                            isPass: flag // 通过/取消通过 true/false
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                            modalDialog.multiReportsAlert(data);
                            defer.resolve(data);
                        }, function(error) {
                            defer.reject(error);
                        });
                    }, function() {
                        defer.reject();
                    });
                }
                return defer.promise;
            },
            openFlowWithVerifierModal: function (options) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/directive/editListPart/service/flowWithVerifier/index.html',
                    windowClass: 'inputModel',
                    backdrop: false,
                    keyboard: false,
                    controller: 'flowWithVerifierCtrl',
                    resolve: {
                        options: function () {
                            return options;
                        }
                    }
                });
                modalInstance.result.then(function (opinion) {
                    defer.resolve(opinion);
                }, function (data) {
                    defer.reject(data);
                });
                return defer.promise;
            },

            /**
             * [trial description] 送审操作
             * @param   {[object]}  scope          [trench description] 当前页面的scope对象
             * @param   {[object]}  methodname     [trench description] 送审的方法
             * @return  {[object]}                 [return description] promise对象
             */
            trial: function (scope, methodname) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                let requestParams = packageParams(scope.data.trench, pageDiffer);
                requestParams = angular.extend(requestParams, methodname);
                this.openFlowWithVerifierModal({
                    title: '送审',
                    placeholder: '送审意见（选填）',
                    canDesignatedAuditor: true
                }).then(function (opinion) {
                    if (pageDiffer.isEdit) { // 表示是编辑页面操作
                        messagePublishService.subscribe('doEditPageOperation', (event, trillParams) => {
                            var params = angular.extend({ opinion: opinion.opinion }, formatParams(opinion.selected));
                            trillParams.Opinion = undefined;
                            trillParams.opinion = undefined;
                            delete trillParams.Opinion;
                            delete trillParams.opinion;
                            scope.loadingPromise = doRequest(angular.extend(params, trillParams), scope.data.trench);
                        }, scope);
                        defer.resolve(opinion);
                    } else {
                        var params = angular.extend({ opinion: opinion.opinion }, formatParams(opinion.selected));
                        requestParams = angular.extend(params, requestParams);
                        scope.loadingPromise = doRequest(requestParams).then(() => {
                            scope.requestData();
                            defer.resolve();
                        }, () => {
                            scope.requestData();
                            defer.reject();
                        });
                    }
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [rejection description]撤稿操作
             * @param   {[type]}  scope       [scope description]当前的scope对象
             * @param   {[type]}  methodname  [methodname description]传入的参数
             * @return  {[type]}              [return description]
             */
            rejection: function (scope, methodname) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                let requestParams = packageParams(scope.data.trench, pageDiffer);
                requestParams = angular.extend(requestParams, methodname);
                modalDialog.inputModel('撤稿', '撤稿原因（选填）', function (opinion) {
                    if (pageDiffer.isEdit) { // 表示是编辑页面操作
                        messagePublishService.subscribe('doEditPageOperation', (event, trillParams) => {
                            scope.loadingPromise = doRequest(trillParams, scope.data.trench);
                        }, scope);
                        defer.resolve(opinion);
                    } else {
                        requestParams = angular.extend({ opinion: opinion }, requestParams);
                        scope.loadingPromise = doRequest(requestParams).then(() => {
                            scope.requestData();
                            defer.resolve();
                        }, () => {
                            defer.reject();
                        });
                    }
                }, '', function () {
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [collect description]收藏
             * @param   {[type]}  scope       [scope description]当前的scope对象
             * @param   {[type]}  methodname  [methodname description]传入的参数
             * @return  {[type]}              [return description]
             */
            collect: function (scope, methodname) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                let requestParams = packageParams(scope.data.trench, pageDiffer);
                requestParams = angular.extend(requestParams, methodname);
                modalDialog.alertType('', '确认收藏稿件', 'ask', true, function () {
                    // requestParams = angular.extend(requestParams);
                    scope.loadingPromise = doRequest(requestParams).then(() => {
                        scope.data.selectedArray = [];
                        defer.resolve();
                    }, () => {
                        defer.reject();
                    });
                });
                return defer.promise;
            },

            /** 
             * [scope description] 稿件签发
             * @param   {[object]}    scope       [scope description] 调用方法的页面对象
             * @param   {[object]}    methodName  [methodName description] 签发参数
             * @param   {[function]}  callback    [callback description] 签发后的回调函数（为了重新签发）
             * @return  {[object]}                [return description] promise对象
             */
            sign: function (scope, methodName, callback) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                modalDialog.confirmModal('签发', '确认直接签发?', function () {
                    if (pageDiffer.isEdit) {
                        messagePublishService.subscribe('doEditPageOperation', (event, signParams) => {
                            doSign(scope, signParams, scope.data.strogeKey || scope.data.trench, callback);
                        }, scope);
                        defer.resolve();
                    } else {
                        let requestParams = packageParams(scope.data.trench, pageDiffer);
                        requestParams = angular.extend(requestParams, methodName);
                        doSign(scope, requestParams, '', callback);
                        defer.resolve();
                    }
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [scope description] 定时签发
             * @param   {[object]}  scope       [scope description] 调用方法的页面对象
             * @param   {[object]}  methodName  [methodName description] 定时签发方法
             * @param   {[object]}  callback    [methodName description] 定时签发方法
             * @return  {[object]}              [return description] promise对象
             */
            timeSign: function (scope, methodName, callback) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                let params = {
                    selectedArray: pageDiffer.list,
                    isNewDraft: pageDiffer.isEdit,
                };
                params = angular.extend(params, methodName);
                editingCenterService.draftTimeSinged(params).then((timeSignParams) => {
                    if (pageDiffer.isEdit) { // 表示是编辑页
                        messagePublishService.subscribe('doEditPageOperation', (event, params) => {
                            timeSignParams = angular.extend(timeSignParams, params);
                            doSign(scope, timeSignParams, scope.data.trench, callback);
                        }, scope);

                    } else {
                        doSign(scope, timeSignParams, '', callback);
                    }
                    defer.resolve();
                }, () => {
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [scope description] iwo共享操作
             * @param   {[object]}  scope       [scope description]  调用方法页面的对象
             * @param   {[object]}  methodname  [methodname description] 请求参数
             * @return  {[object]}              [return description] promise对象
             */
            iwoShare: function (scope, methodname) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                editingCenterService.share((shareObj) => {
                    if (pageDiffer.isEdit) { // 表示是编辑页面操作
                        messagePublishService.subscribe('doEditPageOperation', (event, shareParams) => {
                            scope.loadingPromise = doRequest(shareParams, 'Iwo');
                        }, scope);
                        defer.resolve(shareObj);
                    } else {
                        let requestParams = packageParams('Iwo', pageDiffer); // iwo独有 不用确定渠道
                        requestParams = angular.extend(requestParams, methodname);
                        requestParams = angular.extend(requestParams, shareObj);
                        requestParams.departmentaldocId = $state.params.departmentaldocid || $state.params.departmentDocId;
                        scope.loadingPromise = doRequest(requestParams).then(() => {
                            scope.requestData();
                            defer.resolve();
                        }, () => {
                            defer.reject();
                        });
                    }
                });
                return defer.promise;
            },

            /**
             * [scope description] iwo部门提交&&部门内传递
             * @param   {[object]}  scope   [scope description] 调用该方法的页面对象
             * @param   {[string]}  type    [type description] 操作类型
             * @return  {[object]}          [return description] promise对象
             */
            iwoDepartSubmit: function (scope, type) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                if (pageDiffer.isEdit) { // 表示是编辑页面操作
                    pageDiffer.list = scope.iwoData;
                }
                if (!selectedSingleDoctype(pageDiffer.list)) {
                    modalDialog.alertType('批量操作只允许选择一种稿件类型', '', 'info', 'confirm');
                    return;
                }
                myManuscriptService.departSubmit(pageDiffer.list, type, (requestParams) => {
                    if (pageDiffer.isEdit) { // 表示是编辑页面操作
                        scope.loadingPromise = doRequest(requestParams, 'Iwo');
                    } else {
                        scope.loadingPromise = doRequest(requestParams).then(() => {
                            scope.requestData();
                            defer.resolve();
                        }, () => {
                            defer.reject();
                        });
                    }
                });
                return defer.promise;
            },

            /**
             * [scope description] iwo提交
             * @param   {[object]}  scope       [scope description] 调用方法的scope
             * @param   {[string]}  methodname  [methodname description] 提交的方法名
             * @return  {[object]}              [return description] promise对象
             */
            iwoSubmit: function (scope, methodname) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                if (!pageDiffer.isEdit) {
                    if (!selectedSingleDoctype(pageDiffer.list)) {
                        modalDialog.alertType('批量操作只允许选择一种稿件类型', '', 'info', 'confirm');
                        return;
                    }
                    scope.submitList = pageDiffer.list;
                }
                myManuscriptService.submit(scope.submitList, methodname).then((params) => {
                    if (pageDiffer.isEdit) { // 表示是编辑页
                        scope.loadingPromise = doRequest(params, 'Iwo');
                    } else {
                        scope.loadingPromise = doRequest(params).then(() => {
                            scope.requestData();
                            defer.resolve();
                        }, () => {
                            defer.reject();
                        });
                    }
                }, () => {
                    // 
                });
                return defer.promise;
            },

            /**
             * [zhuanBan description] 报纸转版
             * @param   {[object]}  scope              [scope description] 调用方法的scope
             * @param   {[string]}  banmianMethodName  [banmianMethodName description] 请求版面的方法
             * @return  {[undefined]}                  [return description]
             */
            zhuanBan: function (scope, banmianMethodName) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                const ChnlDocIds = pageDiffer.list.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(ChnlDocIds, scope.requestData).then(function (data) {
                    if (!pageDiffer.isEdit) {
                        let temp = $filter('omit')(scope.data.selectedArray, scope.banmianFilter); // 这里的过滤器是调用控制器定义的
                        if (temp.length) {
                            modalDialog.alertType('请在同一个版面下进行转版操作', '', 'warning', false);
                            defer.reject();
                            return defer.promise;
                        }
                    }
                    let transferData = {
                        title: '转版',
                        opinionTit: '转版意见',
                        isShowDate: true,
                        selectedArr: pageDiffer.list,
                        banmianMethodName: banmianMethodName
                    };
                    editNewspaperService.changeLayoutDraft(transferData, (result) => {
                        let zhuanBanParams = {
                            serviceid: 'mlf_paper',
                            methodname: 'doZhuanBan',
                            PaperId: $state.params.paperid,
                            PubDate: result.dateStr,
                            SrcChnldocIds: result.srcChnldocIds,
                            BanMianID: result.banmianid,
                            SrcBanMianIds: result.SrcBanMianIds,
                            Option: result.option,
                        };
                        if (pageDiffer.isEdit) { // 表示是编辑页
                            messagePublishService.subscribe('doEditPageOperation', () => {
                                scope.loadingPromise = doRequest(zhuanBanParams, 'Newspaper');
                            }, scope);
                            defer.resolve();
                        } else {
                            doRequest(zhuanBanParams).then(() => {
                                scope.loadingPromise = scope.requestData();
                                defer.resolve();
                            }, () => {
                                defer.reject();
                            });
                        }
                    }, () => {
                        // 
                    });
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [scope description] 报纸待用
             * @param   {[object]}   scope  [scope description] 调用方法的scope
             * @return  {[promise]}         [return description] promise对象
             */
            daiYong: function (scope) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                const chnlDocIds = pageDiffer.list.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(chnlDocIds, scope.requestData).then(function (data) {
                    let transferData = {
                        'title': '待用',
                        'opinionTit': '待用说明',
                        'items': pageDiffer.list,
                        'PaperId': $state.params.paperid,
                        'queryMethod': ''
                    };
                    editNewspaperService.cancelSignedViews(transferData, (result) => {
                        let chegaoParams = {
                            'SrcDocIds': result.SrcDocIds,
                            'Option': result.opinion,
                            'serviceid': 'mlf_paper',
                            'methodname': 'doDaiYong',
                            'SrcBanMianIds': result.SrcBanMianIds,
                        };
                        if (pageDiffer.isEdit) { // 表示是编辑页
                            messagePublishService.subscribe('doEditPageOperation', () => {
                                scope.loadingPromise = doRequest(chegaoParams, 'Newspaper');
                            }, scope);
                            defer.resolve();
                        } else {
                            doRequest(chegaoParams).then(() => {
                                scope.loadingPromise = scope.requestData();
                                defer.resolve();
                            }, () => {
                                defer.reject();
                            });
                        }
                    }, () => {
                        //
                    });
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [list description] 报纸上版
             * @param   {[object]}  scope  [scope description] 调用方法的scope
             * @return  {[promise]}        [return description] promise对象
             */
            shangBan: function (scope) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                const ChnlDocIds = pageDiffer.list.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(ChnlDocIds, scope.requestData).then(
                    function (data) {
                        let transferData = {
                            'title': '上版',
                            'opinionTit': '上版意见',
                            'selectedArr': pageDiffer.list,
                            'isShowDate': true,
                            'PaperId': $state.params.paperid,
                            'queryMethod': '',
                            canDesignatedAuditor: true
                        };
                        editNewspaperService.changeLayoutDraft(transferData, (result) => {
                            let methodname = ['doShangBanDaiYong', 'doShangBanJinRi'];
                            let shangBanParams = {
                                serviceid: 'mlf_paper',
                                oprtime: '1m',
                                SrcDocIds: result.srcdocids,
                                BanMianID: result.banmianid,
                                PubDate: result.dateStr,
                                Option: result.option,
                                SrcBanMianIds: result.SrcBanMianIds,
                            };
                            shangBanParams = Object.assign(shangBanParams, formatParams(result.selected));
                            if (pageDiffer.isEdit) { // 表示是编辑页
                                shangBanParams.methodname = methodname[$state.params.newspapertype];
                                messagePublishService.subscribe('doEditPageOperation', () => {
                                    scope.loadingPromise = doRequest(shangBanParams, 'Newspaper');
                                }, scope);
                                defer.resolve();
                            } else {
                                shangBanParams.methodname = scope.status.jrgpreview ? 'doShangBanJinRi' : 'doShangBanDaiYong';
                                scope.loadingPromise = doRequest(shangBanParams).then(() => {
                                    scope.requestData();
                                    defer.resolve();
                                }, () => {
                                    defer.reject();
                                });
                            }
                        }, () => {
                            // 
                        });
                    },
                    function () {
                        defer.reject();
                    }
                );
                return defer.promise;
            },

            /**
             * [list description] 报纸撤稿
             * @param   {[type]}  scope  [scope description] 调用方法的scope
             * @return  {[promise]}      [return description] promise对象
             */
            newsPaperChegao: function (scope) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                const chnlDocIds = pageDiffer.list.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(chnlDocIds, scope.requestData).then(function (data) {
                    let transferData = {
                        'title': '撤稿',
                        'opinionTit': '撤稿原因',
                        'items': pageDiffer.list,
                        'PaperId': $state.params.paperid,
                        'queryMethod': ''
                    };
                    editNewspaperService.cancelSignedViews(transferData, (result) => {
                        let chegaoParams = {
                            'SrcDocIds': result.SrcDocIds,
                            'Option': result.opinion,
                            'serviceid': 'mlf_paper',
                            'methodname': 'doCheGao'
                        };
                        if (pageDiffer.isEdit) { // 表示是编辑页
                            messagePublishService.subscribe('doEditPageOperation', () => {
                                scope.loadingPromise = doRequest(chegaoParams, 'Newspaper');
                            }, scope);
                            defer.resolve();
                        } else {
                            scope.loadingPromise = doRequest(chegaoParams).then(() => {
                                scope.requestData();
                                defer.resolve();
                            }, () => {
                                defer.reject();
                            });
                        }
                    }, () => {
                        //
                    });
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [list description] 报纸传稿
             * @param   {[object]}  scope  [scope description] 调用方法的scope
             * @return  {[promise]}        [return description] promise对象
             */
            newsChuanGao: function (scope) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                let userInfo = $sessionStorage.get('curUserInfo');
                let transferUserObj = localStorageService.get('transferUser') || {};
                let records = transferUserObj[userInfo.ID] || [];
                editNewspaperService.draft({
                    title: '传稿',
                    records: records,
                    confirm: true,
                    selectedArray: pageDiffer.list
                }, (obj) => {
                    let chuanGaoParams = {
                        serviceid: 'mlf_paper',
                        methodname: 'transferMetaDatas',
                        paperid: $state.params.paperid,
                        transferUser: JSON.stringify({
                            'USERID': obj.ID,
                            'USERNAME': obj.UNAME,
                            'TRUENAME': obj.USERNAME
                        }),
                        metadataids: trsspliceString.spliceString(pageDiffer.list, 'METADATAID', ','),
                    };
                    if (pageDiffer.isEdit) { // 表示是编辑页
                        messagePublishService.subscribe('doEditPageOperation', () => {
                            scope.loadingPromise = doRequest(chuanGaoParams, 'Newspaper');
                        }, scope);
                        defer.resolve();
                    } else {
                        scope.loadingPromise = doRequest(chuanGaoParams).then(() => {
                            scope.requestData();
                            defer.resolve();
                        }, () => {
                            defer.reject();
                        });
                    }
                }, () => {
                    // 
                });
                return defer.promise;
            },

            /**
            * [list description] 报纸签发照排
            * @param   {[object]}  scope  [scope description] 调用方法的scope
            * @return  {[promise]}        [return description] promise对象
            */
            newsSign: function (scope) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                const chnlDocIds = pageDiffer.list.map((item) => item.CHNLDOCID).join(',');
                let markBanmian = pageDiffer.list[0].CHANNELID;
                let markPubDate = pageDiffer.list[0].PUBDATE;
                let banmianFlag = false,
                    pubDateFlag = false,
                    alertContent = '同期同版';
                if (pageDiffer.list.length > 1) {
                    for (var i = 0; i < pageDiffer.list.length; i++) {
                        if (pageDiffer.list[i].CHANNELID != markBanmian) {
                            banmianFlag = true;
                        }
                        if (pageDiffer.list[i].PUBDATE != markPubDate) {
                            pubDateFlag = true;
                        }
                    }
                }
                alertContent = banmianFlag && pubDateFlag ? '同期同版' : banmianFlag ? '相同版面' : pubDateFlag ? '相同见报日期' : alertContent;
                if (banmianFlag || pubDateFlag) {
                    modalDialog.alertType('', '所选稿件存在不是' + alertContent + '的稿件，请确定是否强制签发', 'warning', true, function () {
                        editingCenterService.isListDocCanOper(chnlDocIds, scope.requestData).then(function (data) {
                            sensitiveWordCheckService.SensitiveWordsAndCareful(pageDiffer.list, '', 3).then(
                                function () {
                                    newsSignZp(pageDiffer, scope);
                                },
                                function () {
                                    newsSignZp(pageDiffer, scope);
                                }
                            );
                        }, function () {
                            defer.reject();
                        });
                    }, null, null, null, '强制签发');
                } else {
                    editingCenterService.isListDocCanOper(chnlDocIds, scope.requestData).then(function (data) {
                        sensitiveWordCheckService.SensitiveWordsAndCareful(pageDiffer.list, '', 3).then(
                            function () {
                                newsSignZp(pageDiffer, scope);
                            },
                            function () {
                                newsSignZp(pageDiffer, scope);
                            }
                        );
                    }, function () {
                        defer.reject();
                    });
                }
                return defer.promise;
            },

            /**
            * [propagandaReview description]宣传部送审
            * @param   {[type]}  scope       [params description]
            * @param   {[type]}  methodname  [trench description]
            * @return  {function}            [return description]
            **/
            propagandaReview: function (scope, methodname) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                let requestParams = packageParams(scope.data.trench, pageDiffer);
                requestParams = angular.extend(requestParams, methodname);
                modalDialog.inputModel('送审', '送审意见（选填）', function (opinion) {
                    requestParams = angular.extend({ opinion: opinion }, requestParams);
                    scope.loadingPromise = doRequest(requestParams).then(() => {
                        scope.requestData();
                        defer.resolve();
                    }, () => {
                        defer.reject();
                    });
                }, '', function () {
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [params description] 废稿操作
             * @param   {[type]}  scope       [params description]
             * @param   {[type]}  methodname  [trench description]
             * @return  {[type]}              [return description]
             */
            delete: function (scope, methodname) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                let requestParams = packageParams(scope.data.trench, pageDiffer);
                requestParams = angular.extend(requestParams, methodname);
                modalDialog.inputModel('废稿', '废稿原因（可选）', function (opinion) {
                    requestParams = angular.extend({ opinion: opinion }, requestParams);
                    if (pageDiffer.isEdit) { // 表示是编辑页面操作
                        scope.loadingPromise = doRequest(requestParams, scope.data.trench).then(function () {
                            defer.resolve();
                        }, function () {
                            defer.reject();
                        });
                    } else {
                        scope.loadingPromise = doRequest(requestParams).then(() => {
                            if (scope.requestData) {
                                scope.requestData();
                            }
                            defer.resolve();
                        }, () => {
                            defer.reject();
                        });
                    }
                }, '', function () {
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [publish description] 发布方法
             * @param   {[obj]}  params  [params description] 请求参数
             * @param   {[str]} trench   [trench description] 渠道名称
             * @return  {[type]}         [return description]
             */
            publish: function (params, trench) {
                modalDialog.confirmModal('提示', '确认直接签发吗？', function () {
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                        (data) => {
                            successAfterRequest('签发', trench, data);
                        },
                        (error) => {
                            failAfterRequest('签发', trench);
                        }
                    );
                });
            },

            // /**
            //  * [getVersion description] 获取流程记录
            //  * @param {String} metadataid 稿件id
            //  * @return {[type]} [description]
            //  */
            // getVersion: function (metadataid) {
            //     let deffer = $q.defer();
            //     let params = {
            //         serviceid: 'mlf_extversion',
            //         methodname: 'queryVersions',
            //         MetaDataId: metadataid
            //     };
            //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
            //         deffer.resolve(initVersionService.getDayContent(data, 'push'));
            //     });
            //     return deffer.promise;
            // },

            /**
             * [getVersion description] 获取流程记录
             * @param {String} mediaType 渠道类型参数
             * @param {String} metadataid 稿件id
             * @return {[type]} [description]
             */
            getVersion: function (mediaType, metadataid) {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'wcm61_socialprocess',
                    methodname: 'queryToJson',
                    objType: mediaType,
                    ObjId: metadataid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    if (Object.prototype.toString.call(data) === '[object Array]') {
                        deffer.resolve(initVersionService.getDayContent(data, 'push'));
                    }
                });
                return deffer.promise;
            },

            /**
             * [openPersonalVersionTime description] 打开流程版本详情页
             * @param  {[type]} iwometadataid [description] iwo的稿件id
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            openPersonalVersionTime: function (iwometadataid, item) {
                var path = mediaPath[item.MEDIATYPE];
                getRelatedversion(iwometadataid, item.VERSIONNUM).then(function (data) {
                    var params = {
                        // 融合
                        metadataid: iwometadataid,
                        iwoobjectversionid: item.OBJECTVERSIONID,
                        wzobjectversionid: angular.isDefined(data.web) ? data.web.objversionId : '',
                        bzobjectversionid: angular.isDefined(data.paper) ? data.paper.objversionId : '',
                        appobjectversionid: angular.isDefined(data.app) ? data.app.objversionId : '',
                        wxobjectversionid: angular.isDefined(data.wechat) ? data.wechat.objversionId : '',
                        versionum: item.VERSIONNUM,
                    };
                    item.url = $state.href(path, params);
                    var url = item.url;
                    window.open(url);
                });
            },

            /**
             * [previewLoadDirective description]查看页动态加载指令
             * @param   {[obj]}  element      [element description]dom对象
             * @param   {[obj]}  compile      [compile description]complie对象
             * @param   {[obj]}  scope        [scope description]scope对象
             * @param   {[str]}  html         [scope description]富文本字段
             * @param   {[str]}  video        [scope description]视频字段
             * @return  {[type]}              [return description]
             */
            previewLoadDirective: function (element, compile, scope, html, video) {
                var htmlContent = html
                    ? html
                    : '<div trs-play-audio-video adjustsize class="padding20 " ng-bind-html="data.detail.HTMLCONTENT |trsSceHtmlContent">'; // 默认值为新媒体渠道默认值
                htmlContent = compile(htmlContent)(scope);
                element.find('audiovideo').append(htmlContent);
                var videoUpload = video ? video : '<div trs-upload-for-xj-video-draft list="data.detail" preview="true"></div>'; // 默认值为新媒体渠道默认值
                videoUpload = compile(videoUpload)(scope);
                element.find('videocon').append(videoUpload);
                previewService.drawVideoMark(false, true);
            },

            /**
             * [waste description] 废稿操作
             * @param   {[object]}     params  [params description]请求参数
             * @return  {[promise]}            [return description]请求返回值
             */
            waste: function (params) {
                modalDialog.inputModel('废稿', '废稿原因（可选）', function (content) {
                    params = angular.extend(
                        {
                            opinion: content,
                        },
                        params
                    );
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                        function (data) {
                            if (angular.isArray(data.REPORTS)) {
                                modalDialog.multiReportsAlert(data, function () {
                                    messagePublishService.publish('refresh', true);
                                });
                            } else {
                                modalDialog.alertType('', data.DETAIL, 'warning', 'confirm');
                            }
                        },
                        function (data) {
                            modalDialog.multiReportsAlert(data, function () {
                                messagePublishService.publish('refresh', true);
                            });
                        }
                    );
                });
            },

            /**
             * [export description] 稿件导出
             * @param   {[object]}  params  [params description] 请求参数
             * @param   {[array]}  array   [array description] 选中的稿件集合
             * @return  {[type]}          [return description]
             */
            export: function (params, array) {
                examineDoctype(array, '新闻，图集').then(
                    (data) => {
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                            function (data) {
                                window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                                successAfterRequest('导出', '', '', 'clearArray');
                            },
                            function (data) { }
                        );
                    },
                    (error) => {
                        modalDialog.alertType('', '只能导出新闻稿或图集稿', 'warning', false);
                    }
                );
            },

            /**
             * [outsource description]邮件外发
             * @param   {[object]} params  [params description]请求参数
             * @param   {[array]}  array   [array description] 选中的稿件集合
             * @return  {[undefined]}      [return description]
             */
            outsource: function (params, array) {
                examineDoctype(array, '新闻，图集').then(
                    (data) => {
                        editingCenterService.outSending('', function (result) {
                            params = angular.extend(
                                {
                                    Emails: trsspliceString.spliceString(result.selectItems, 'EMAIL', ','),
                                },
                                params
                            );
                            return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                                modalDialog.alertType('稿件外发成功！', '', 'success', false, function () {
                                    messagePublishService.publish('refresh', true);
                                });
                            });
                        });
                    },
                    (error) => {
                        modalDialog.alertType('', '只能外发新闻稿或图集稿', 'warning', false);
                    }
                );
            },

            /**
             * [scope description] 修订
             * @param   {[object]}  scope   [scope description] 调用方法的页面对象
             * @param   {[object]}  params  [params description] 请求参数
             * @return  {[object]}          [return description] promise对象
             */
            revise: function (scope, params) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                params = angular.extend({
                    serviceid: 'mlf_modifydoc',
                    methodname: 'appointDocToUserOfNewMedia'
                }, params);
                editingCenterService.channelsRevise(params, function () {
                    if (scope.requestData) {
                        scope.requestData();
                    }
                    if (pageDiffer.isEdit) {
                        successAfterRequest(scope.data.trench);
                    } else {
                        successAfterRequest();
                    }
                    defer.resolve();
                }, function () {
                    // 暂时啥都不用做
                    defer.reject();
                });
                return defer.promise;
            },

            /**
             * [requestGraph description]
             * @param   {[arr]}  items       [items description] 列表数据集合
             * @param   {[obj]}  params      [params description] 请求参数
             * @param   {[str]}  idName      [key description] 主要使用的ID名称
             * @return  {[promise]}          [return description] promise
             */
            requestGraph: function (items, params, idName) {
                var defer = $q.defer();
                if (!items || !items.length) {
                    defer.resolve([]);
                } else {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        angular.forEach(items, function (value, key) {
                            value.ALLIMG = data[value[idName]];
                        });
                        defer.resolve(items);
                    });
                }
                return defer.promise;
            },

            /*
            *[retraction description]取消签发操作
            * @param   {[obj]}  params      [params description] 请求参数
            * @param   {[str]}  trench      [key description] 主要使用的ID名称
            * @return  {[type]}  [return description]
            */
            retraction: function (scope, methodName) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                let requestParams = packageParams(scope.data.trench, pageDiffer);
                requestParams = angular.extend(requestParams, methodName);
                modalDialog.inputModel('是否取消签发', '取消签发原因 (选填)', function (opinion) {
                    requestParams = angular.extend({ opinion: opinion }, requestParams);
                    if (pageDiffer.isEdit) { // 表示是查看页面操作
                        scope.loadingPromise = doRequest(requestParams, scope.data.trench).then(function () {
                            defer.resolve();
                        }, function () {
                            defer.reject();
                        });
                    } else {
                        scope.loadingPromise = doRequest(requestParams).then(() => {
                            if (scope.requestData) {
                                scope.requestData();
                            }
                            defer.resolve();
                        }, () => {
                            defer.reject();
                        });
                    }
                }, '', function () {
                    defer.reject();
                });
                return defer.promise;
            },


            /**
            * [paperCancelSignedDraft description]报纸取消签发方法
            * @param   {[array]}  scope  [item description] 稿件集合
            * @return  {[type]}           [return description]
            */
            paperCancelSignedDraft: function (scope) {
                var defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                isAcross(pageDiffer.list).then(function () {
                    const chnlDocIds = pageDiffer.list.map((item) => item.CHNLDOCID).join(',');
                    editingCenterService.isListDocCanOper(chnlDocIds, scope.requestData).then(() => {
                        var transferData = {
                            'title': '取消签发',
                            'opinionTit': '取消签发意见',
                            'items': pageDiffer.list,
                            'PaperId': $state.params.paperid,
                            'queryMethod': 'queryYiQianDocs'
                        };
                        editNewspaperService.cancelSignedViews(transferData, (result) => {
                            var params = {
                                'SrcDocIds': result.SrcDocIds,
                                'Option': result.opinion ? result.opinion : '',
                                'serviceid': 'mlf_paper',
                                'methodname': 'doQuXiaoQF'
                            };
                            scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(() => {
                                modalDialog.alertType('取消签发成功', '', 'success', false, function () {
                                    if (pageDiffer.isEdit) {
                                        storageListenerService.addListenerToNewspaper();
                                        $window.close();
                                    } else {
                                        scope.requestData();
                                    }
                                    defer.resolve();
                                });
                            }, () => {
                                if (scope.requestData) {
                                    scope.requestData();
                                }
                                defer.reject();
                            });
                        }, function () {
                            defer.reject();
                        });
                    }, function () {
                        defer.reject();
                    });
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            },

            /*
            *[retraction description]发稿单操作
            * @param   {[obj]}  selectedArray      [params description] 选择的数组
            * @param   {[str]}  paramsOne      [key description] 发稿单参数1
            * @param   {[str]}  paramsTwo      [key description] 发稿单参数2
            * @return  {[type]}  [return description]
            */
            draftlist: function (scope, params, editFGDParams) {
                let defer = $q.defer();
                let pageDiffer = distinguishListOrEdit(scope);
                const chnlDocIds = pageDiffer.list.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(chnlDocIds, scope.requestData).then(function (data) {
                    let requestParams = packageParams(scope.data.trench, pageDiffer);
                    params = angular.extend(params, requestParams);
                    if (editFGDParams) {
                        editFGDParams = angular.extend(editFGDParams, requestParams);
                    }
                    editingCenterService.draftList(pageDiffer.list, params, () => {
                        scope.requestData();
                    }, editFGDParams);
                }, function () {
                    defer.resolve();
                });
                return defer.promise;
            },

            /**
             * [selectedArray description] 多元分发
             * @param   {[type]}  selectedArray  [selectedArray description]
             * @return  {[type]}                 [return description]
             */
            distribution: function (selectedArray) {
                if (!editingCenterService.isSameDocType(selectedArray, 'DOCTYPEID')) {
                    modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                    return;
                }
                var temp = $filter('pick')(selectedArray, examDistributionType);
                if (temp.length < 1) {
                    editingCenterService.distribution(selectedArray, '19', selectedArray[0].DOCTYPEID, 'kuaiBaoDaiBianDistribute', function () {
                        selectedArray = [];
                        messagePublishService.publish('refresh', false);
                        // modalDialog.alertType("发稿单修改成功", "", "success", false, function() {
                        // });
                    });
                } else {
                    modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻、视频、图集', 'warning', 'confirm', function () { });
                }
            },
            getReviseInfo: getReviseInfo,
        };
    },
]);
